import { createSlice } from '@reduxjs/toolkit';

import store from '../../../store.js';

const keyLookUp = {
  '/dashboard': 0,
  '/tasks': 1,
  '/executions': 2,
  '/sequences': 3,
  '/connections': 4,
  '/engines': 5,
  '/sharedconfig': 6,
  '/sharedfield': 7,
  '/admin/dashboard': 8,
  '/admin/permissions': 9,
  '/health': 10,
  '/version': 11,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: { activeKey: 0 },
  reducers: {
    setActiveKey(state, action) {
      state.activeKey = action.payload;
    },
    routeActiveKey(state, action) {
      const parts = window.location.pathname.split('/').slice(2);
      let key = null;
      while (parts.length) {
        const full = '/' + parts.join('/');
        if (full in keyLookUp) {
          key = full;
          break;
        }
        parts.pop();
      }
      if (key) {
        state.activeKey = keyLookUp[key];
      } else {
        state.activeKey = -1;
      }
    },
  },
});

export const { setActiveKey, routeActiveKey } = sidebarSlice.actions;

export default sidebarSlice.reducer;
